import { render, staticRenderFns } from "./ElectronicVIT.vue?vue&type=template&id=55b2ee2d&scoped=true&"
import script from "./ElectronicVIT.vue?vue&type=script&lang=js&"
export * from "./ElectronicVIT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b2ee2d",
  null
  
)

export default component.exports